export default function stripMarkdown(text: string): string {
  const stripper = /^[ \t]*(?:[-_#*~>+|!=]|\d+\.).*|^```(?:.*\n)+?```|\[(.*)\]: .*|^:::(?:.*\n)+?:::/gm;
  const links = /\[(.*?)\](:?\((.*?)\))?/gm;

  const cleaned = text.replace(stripper, '').replace(links, '$1');
  const lines = cleaned.match(/.+/g);

  if (lines === null) {
    return '';
  } else {
    return lines[0];
  }
}
